module.exports = __webpack_public_path__ + "img/s3Model1.0b2fcfb7.webp";